import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { JuniorhackerComponent } from './juniorhacker.component';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';



@NgModule({
  declarations: [JuniorhackerComponent],
  imports: [
    RouterModule.forChild([
      { path: '', component: JuniorhackerComponent },
    ]),
    CommonModule,
    ReactiveFormsModule
  ]
})
export class JuniorhackerModule { }
